export class ContractorBaseFilter {

  constructor() { }

  name: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/home/models/contractor-base-filter.ts